<template name="filterbar">
  <div class="w-full px-8 mb-4 bg-white h-12 flex content-center justify-between">
    <div class="flex ">
      <div v-if="!nosearch">
        <input 
          type="search"
          class="filter-bar-search focus:outline-none"
          name="search"
          v-model="search"
          placeholder="Enter search term..."
        />
        <i class="fas fa-times text-sm absolute -ml-8 mt-4 cursor-pointer hover:opacity-50" 
            @click="clearTags()" 
            title="Clear search" v-show="search.length > 0"></i>
      </div>
      <slot name="filter"> </slot>
    </div>
    <div class="flex flex-row content-center pt-1">
      <slot name="actions"> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "filterbar",
  props: {
    preset: {
    type: String,
    default: "",
  },
    nosearch: {
    type: Boolean,
    default: false,
  },
  },
  data() {
    return {
      search: this.preset != undefined ? this.preset : "",
    };
  },
  watch: {
    search(newValue) {
      this.$emit('searchChanged', this.search)
    },
    preset: {
    // the callback will be called immediately after the start of the observation
    immediate: true, 
    handler (val, oldVal) {
      this.search = val
    }
  }
  },
  methods: {
    clearTags() {
      this.search = ""
    },
  }
};
</script>

